<template>
    <!-- 现货库存 板材库 -->
    <div class="templete">
        <div class="search_box search_box_f clearfix">
            <el-input class="search_input search_inputBox" v-model="params.bale_no" @keyup.enter.native="getList(true)" placeholder="捆包号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-model="params.breed_id" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="品名" filterable @visible-change="getSelectWarehouseList('breed_id')">
                <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.brand_id" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="品牌" filterable @visible-change="getSelectWarehouseList('brand_id')">
                <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.grade_id" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="等级" filterable @visible-change="getSelectWarehouseList('grade_id')">
                <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.thickness" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="厚度" filterable @visible-change="getSelectWarehouseList('original_thickness')">
                <el-option v-for="(list,index) in selectMapC.original_thickness" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.length" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="长度" filterable @visible-change="getSelectWarehouseList('original_length')">
                <el-option v-for="(list,index) in selectMapC.original_length" :key="index" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.status"  multiple collapse-tags placeholder="销售状态" filterable>
                <el-option v-for="list in statusList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.warehouse_id" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="仓库" filterable @visible-change="getSelectWarehouseList('warehouse_id')">
                <el-option v-for="list in selectMapC.warehouse_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-model="params.supplier_id" @keyup.enter.native="getList(true)" multiple collapse-tags placeholder="供应商" filterable @visible-change="getSelectWarehouseList('supplier_id')">
                <el-option v-for="list in selectMapC.supplier_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <!-- <div class="search_time search_inputBox">
                <el-date-picker v-model="inbound_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="入库时间"></el-date-picker>
            </div> -->
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.contract_no" @keyup.enter.native="getList(true)" placeholder="合同号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" v-model="params.container_no" @keyup.enter.native="getList(true)" placeholder="货柜号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.bill_lading_no" placeholder="提单号" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.original_bale" placeholder="供单号" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.opening_company_id" placeholder="货权单位" filterable @visible-change="getSelectWarehouseList('opening_company_id')">
                <el-option v-for="list in selectMapC.opening_company_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.check_status" placeholder="检尺状态">
                <el-option :value="999" label="全部检尺状态"></el-option>
                <el-option :value="1" label="已检尺"></el-option>
                <el-option :value="0" label="未检尺"></el-option>
            </el-select>
            <div class="search_time search_inputBox" v-if="isShowMore">
                <el-input v-model="params.price_min" placeholder="价格区间" @keyup.enter.native="getList(true)" size="mini"></el-input>
                ~
                <el-input v-model="params.price_max" placeholder="价格区间" @keyup.enter.native="getList(true)" size="mini"></el-input>
            </div>
            <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.storage_age" placeholder="库龄" size="mini"></el-input>
            <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.storage_location" placeholder="库位" size="mini"></el-input>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.attribute_id" multiple collapse-tags placeholder="属性" filterable @visible-change="getSelectWarehouseList('attribute_id')">
                <el-option v-for="list in selectMapC.attribute_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.color_id" multiple collapse-tags placeholder="选色" filterable @visible-change="getSelectWarehouseList('color_id')">
                <el-option v-for="list in selectMapC.color_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.place_origin" multiple collapse-tags placeholder="产地" filterable @visible-change="getSelectWarehouseList('place_origin')">
                <el-option v-for="list in selectMapC.place_origin" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-select class="search_select search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.locker_id" multiple collapse-tags placeholder="锁定人" filterable @visible-change="getSelectWarehouseList('locker_id')">
                <el-option v-for="list in selectMapC.locker_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select>
            <el-input class="search_input search_inputBox" v-if="isShowMore" @keyup.enter.native="getList(true)" v-model="params.remark" placeholder="备注" size="mini"></el-input>
            <!-- <el-select class="search_select search_inputBox" v-model="params.port_id" multiple collapse-tags placeholder="目的港">
                <el-option v-for="list in portList" :key="list.id" :value="list.id" :label="list.name"></el-option>
            </el-select> -->
            <!-- <el-input class="search_input search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input> -->
            <div class="searchBtnList clearfix flex">
                <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <div class="reset fcolor" style="margin: 0 20px;">
                    <el-checkbox v-model="is_like">精确查找</el-checkbox>
                </div>
                <div @click="share"><i class="iconfont icon-fenxiang shareBut pointer"></i></div>
                <!-- <el-button  class="publicBtn" @click="filterDialogVisible=!filterDialogVisible">过滤</el-button> -->
            </div>
            <div class="execlInsert execlInsertHasFilter clearfix">
                <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                <span class="excel_btn" @click="exportExcelBill"><i class="excel-icon"></i>excel导出</span>
            </div>
        </div>
        <div class="tableBox">
            <tabletem :isSetCol="true" scene="inventory.spots"  :isLoading="tableLoading" :tablecol="tableCol" :isShowIndex="true" :tabledata="list" @magnifierClick="magnifierClick" @sortTable="sortTable" @getRow="getRow" @relativefile="relativeFile" @rowClick="rowClick"></tabletem>
        </div>
        <div class="totalCal">
            <div class="totalNumber" v-if="totalObj.numbers||Number(totalObj.numbers)==0">总件数: {{totalObj.numbers}}</div>
            <div class="totalNumber" v-if="totalObj.cube_total||Number(totalObj.cube_total)==0">总方数: {{totalObj.cube_total}}</div>
            <div class="totalNumber" v-if="totalObj.lock_numbers||Number(totalObj.lock_numbers)==0">锁定件数: {{totalObj.lock_numbers}}</div>
            <div class="totalNumber" v-if="totalObj.lock_cube_total||Number(totalObj.lock_cube_total)==0">锁定方数: {{totalObj.lock_cube_total}}</div>
            <div class="totalNumber">选中件数: {{selectRow.length}}</div>
            <div class="totalNumber">选中立方: {{selectCube}}m³</div>
        </div>
        <div class="pageBox">
            <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.spots" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <relativeFile :dialog="downLoadFileDialog" @closeDialog="()=>{this.downLoadFileDialog = false}" :files="downFilesList"></relativeFile>
        <saledetail :dialogVisiblesale="dialogVisibleSale" :id="saleDetailId" @close="()=>{this.saleDetailId = false;}"></saledetail>
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    import relativeFile from '../../components/downloadRelativeFile.vue'
    import saledetail from '../../components/saleDetail.vue'
    export default {
        components:{
            pagination,
            tabletem,
            relativeFile,
            saledetail
        },
        data(){
            return{
                dialogVisibleSale:false,
                saleDetailId:"",
                tableLoading:false,
                categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
                categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
                categoryScrapType:localStorage.dw_erp_category.indexOf("scrap")!=-1?true:false,
                categoryGlulamType:localStorage.dw_erp_category.indexOf("glulam")!=-1?true:false,
                dialogVisibleWidth:false,
                isShowMore:false,
                widthList:[],
                inbound_time:"",
                params:{
                    supplier_id:"",
                    breed_id:"",
                    thickness:"",
                    length:"",
                    grade_id:"",
                    bale_no:"",
                    warehouse_id:"",
                    attribute_id:"",
                    color_id:"",
                    price_min:"",
                    price_max:"",
                    contract_no:"",
                    bill_lading_no:"",
                    storage_age:"",
                    storage_location:"",
                    opening_company_id:"",
                    original_bale:"",
                    check_status:"",
                    locker_id:"",
                    container_no:"",
                    field:"",
                    sort:"",
                    remark:"",
                    per_page: 50,
                    page:1
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                selectMapC:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    port_id:[],
                    grade_id:[],
                    attribute_id:[],
                    color_id:[],
                    locker_id:[],
                    warehouse_id:[],
                    original_length:[],
                    original_thickness:[],
                    opening_company_id:[],
                    place_origin:[]
                },
                searchCityList:[],
                statusList:[],
                // dialog
                dialogVisible : false,
                tableCol:[	
                    {colName:"资源状态",colKey:"stock_status_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"检尺状态",colKey:"check_status_text",colWidth:75,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"捆包号",colKey:"bale_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供单号",colKey:"original_bale",colWidth:65,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"销售品名",colKey:"sales_breed",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"产品图片",colKey:"thumbnail",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true},
                    {colName:"等级",colKey:"grade",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"属性",colKey:"attribute",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"选色",colKey:"color",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"编码",colKey:"code",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"厚度",colKey:"original_thickness",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"长度",colKey:"original_length",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"片数",colKey:"pieces",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"层数",colKey:"sales_layer_number",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"外商单号",colKey:"ex_order_no",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"总宽度",colKey:"sales_width_total",colWidth:80,isSetWidth:true,isCanClick:true,isShow:true,isColor:true,isHideShowClickImg:true,isHideCanClickColor:true},
                    {colName:"销售立方",colKey:"sales_cube",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true,isSort:true},
                    {colName:"挂牌价",colKey:"listed_price",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"供应商",colKey:"supplier",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"产地",colKey:"place_origin",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"仓库",colKey:"warehouse",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货权单位",colKey:"opening_company",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"销售状态",colKey:"status_text",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isMagnifier:true},
                    {colName:"锁定人",colKey:"locker_name",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"锁定等级",colKey:"lock_level",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,islockLevel:true},
                    {colName:"品牌",colKey:"brand",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"提单号",colKey:"bill_lading_no",colWidth:110,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"目的港",colKey:"purpose_port",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"入库时间",colKey:"inbound_time",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isSort:true},
                    {colName:"到期日",colKey:"expiry_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库龄",colKey:"storage_age",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"库位",colKey:"storage_location",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"挂牌金额",colKey:"listed_amount",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"关联文件",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isRelativeFile:true},
                    {colName:"可用立方",colKey:"enable_cube",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                ],
                totalObj:{
                    numbers:0,
                    cube_total:0,
                    lock_numbers:0,
                    lock_cube_total:0
                },
                fields:"",
                filterDialogVisible:false,
                filter:"",
                selectRow:[],
                selectCube:0.0000,
                downLoadFileDialog:false,
                downFilesList:[],
                is_like:false,
            }
        },
        created(){
            this.postFunc("/erp/inventory.spots.status",{},res=>{
                this.statusList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            magnifierClick(obj){
                this.list.forEach(item=>{
                    if(item.id == obj.row.id){
                        this.saleDetailId = item.order_id;
                    }
                })
            },
            relativeFile(obj){
                this.downLoadFileDialog = !this.downLoadFileDialog;
                this.downFilesList = obj.files;
            },
            getRow(row){
                this.selectRow = row;
                let number = 0;
                this.selectRow.forEach(item=>{
                    number += Number(item.sales_cube)
                })
                this.selectCube = this.keepLimit(number)
            },
            share(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    let arr = [];
                    for(let i=0;i<this.selectRow.length;i++){
                        arr.push(this.selectRow[i].id)
                    }
                    this.$exportExecl("/erp/inventory.share","资源分享",{ids:arr})
                }
            },
            exportExcelBill(){
                this.$exportExecl("/erp/inventory.spots.export","板材现货库存",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params,'','spots').then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.params.is_like = this.is_like;
                this.$postColumnList("/erp/inventory.spots",this.params,res=>{
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.totalObj=res.data.data.total;
                    this.totalObj.cube_total=this.keepLimit(this.totalObj.cube_total)
                    this.totalObj.lock_cube_total=this.keepLimit(this.totalObj.lock_cube_total)
                    this.list.forEach((item,ind)=>{
                        if(item.inbound_time&&item.inbound_time!=0){
                            this.list[ind].inbound_time = this.formatTimeSecond(item.inbound_time*1000) 
                        }else{
                            this.list[ind].inbound_time ='';
                        }
                        // if(item.expiry_time){
                        //     this.list[ind].expiry_time = this.formatTime(this.list[ind].expiry_time+"000")
                        // }else{
                        //     this.list[ind].expiry_time = "";
                        // }
                        // this.list[ind].sales_width_total = parseInt(this.list[ind].sales_width_total);
                        item.baseColor = "";
                        if(item.status==1&&item.lock_status==0){
                            item.baseColor="#222";
                        }else if(item.status==2){
                            item.baseColor="#155BD4";
                        }else if(item.status==3){
                            item.baseColor="#B400FF";
                        }else if(item.status==4){
                            item.baseColor="#007B04";
                        }else if(item.status==1&&item.lock_status==1){
                            item.baseColor="#FF0000";
                        }
                        if(item.order_id){
                            item.isMagnifier = true;
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                        // if(item.colKey=="status_text"||item.colKey=="stock_status_text"){
                        //     if(this.fields.indexOf(",status,")!=-1){
                        //         item.isShow=true;
                        //     }
                        // }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            rowClick(obj){
                if(obj.name=="sales_width_total"){
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            this.widthList = item.sales_width;
                            this.dialogVisibleWidth = true;
                        }
                    })
                }
            },
            //表格排序
            sortTable(sort){
                this.params.field = sort.order ? sort.prop:'';
                this.params.sort = sort.order == "ascending"?"asc":sort.order == "descending"?"desc":"";
                this.getList();
            },
            reset(){
                // this.inbound_time="";
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
.shareBut{
    // margin-right: 3px;
    // width: 18px;
    // height: 18px;
    // position: relative;
    // top: 4px;
    color:#B21111;
    font-size: 24px;
}
</style>
